<template>
    <Toast/>
    <div v-if="$can('view','ship_agent')" class="pt-4 pb-2">
        <div class="flex justify-content-between align-items-end">
            <h1 class="my-auto"> Ship Agent </h1>
            <div v-if="$can('add','ship_agent')" class="card p-1">
                <Button data-cy="new_ship_agent_button" class="p-button-text p-button-success" @click="openModal" v-tooltip.bottom="'New Ship Agent'">
                    <i class="pi pi-plus" style="font-size: 1.5rem" ></i>
                </Button>
            </div>
        </div>

        <Dialog data-cy="new_ship_agent_modal" header="New Ship agent" v-model:visible="displayModal" :modal="true" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}">
            <div class="container">
                <form id="from_new_ship_agent" @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid">
                    <div class="row justify-content-center">
                        <div class="col-10 md:col-12 pt-3">
                            <div class="p-float-label">     
                                <InputText id="name" v-model="v$.name.$model" :class="{'p-invalid':v$.name.$invalid && submitted || ship_agent_errors.name}" @input="name = $event.target.value.toUpperCase()"/>
                                <label for="name" :class="{'p-error':v$.name.$invalid && submitted}"> Name </label>
                            </div>
                            <small v-if="Object.keys(ship_agent_errors).length !== 0 && ship_agent_errors.name" class="p-error"><span v-for="error in ship_agent_errors.name" :key="error">{{error}}<br></span></small>
                            <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{v$.name.required.$message.replace('Value', 'Name')}}</small>
                        </div>
                    </div>
                    <!--
                    <div class="row justify-content-center">
                        <div class="col-10 md:col-12 pt-3">
                            <div class="p-float-label">
                                <Dropdown id="id_cruise_line" v-model="id_cruise_line" :options="all_cruise_lines" optionLabel="name" :filter="true" placeholder="Select a Cruise line">
                                    <template #value="slotProps">
                                        <div v-if="!id_cruise_line">
                                            <span> {{slotProps.placeholder}} </span>
                                        </div>
                                        <div v-else-if="slotProps.value">
                                            <span>{{slotProps.value.name}}</span>
                                        </div>
                                    </template>
                                    <template #option="slotProps">
                                        <div> {{slotProps.option.name}}</div>
                                    </template>
                                </Dropdown>
                            </div>
                            <small v-if="Object.keys(ship_agent_errors).length !== 0 && ship_agent_errors.id_cruise_line" class="p-error"><span v-for="error in ship_agent_errors.id_cruise_line" :key="error">{{error}}<br></span></small>
                            <small v-if="(v$.id_cruise_line.$invalid && submitted) || v$.id_cruise_line.$pending.$response" class="p-error">{{v$.id_cruise_line.required.$message.replace('Value', 'id_cruise_line')}}</small>
                        </div>
                    </div>
                    -->
                    <div class="row">
                        <div class="col-10 md:col-12">
                            <span v-if="id_cruise_line">
                                <span v-for="cruise_line in id_cruise_line" :key="cruise_line">
                                    <Chip :label="cruise_line.name" class="mr-2 mb-2"/>
                                </span>
                            </span>
                            <ListBox v-model="id_cruise_line" :options="all_cruise_lines" optionLabel="name" :multiple="true" :filter="true" listStyle="max-height:250px;"/>
                            <small v-if="Object.keys(ship_agent_errors).length !== 0 && ship_agent_errors.id_cruise_line" class="p-error"><span v-for="error in ship_agent_errors.id_cruise_line" :key="error">{{error}}<br></span></small>
                            <small v-if="(v$.id_cruise_line.$invalid && submitted) || v$.id_cruise_line.$pending.$response" class="p-error">{{v$.id_cruise_line.required.$message.replace('Value', 'At least one cruise line')}}</small>
                        </div>
                    </div> 
                </form>
            </div>
            <template #footer>
                <Button data-cy="create_ship_agent_button" form="from_new_ship_agent" type="submit" label="Submit" class="p-button-raised"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
// import Dropdown from 'primevue/dropdown'
import ListBox from 'primevue/listbox'
import Chip from 'primevue/chip';
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        Dialog,
        Button,
        // Dropdown,
        InputText,
        Toast,
        ListBox,
        Chip
    },
    data() {
        return {
            displayModal: false,
            name: '',
            id_cruise_line:'',
            ship_agent_errors: {},
            submitted: false,
            showMessage: false,
        }
    },
    created() {
        this.$store.dispatch('load_all_cruise_lines')
    },
    computed: {
        all_cruise_lines: function() {
            return this.$store.getters.all_cruise_lines
        },
        get_ship_agent_errors: function() {
            return this.$store.getters.get_ship_agent_errors
        }
    },
    methods: {
        openModal() {
            this.displayModal = true;
        },
        closeModal() {
            this.displayModal = false;
        },
        async add_ship_agent() {
            let ship_agent = { 
                name: this.name,
                id_cruise_line:this.id_cruise_line,
            }
            await this.$store.dispatch('create_ship_agent', ship_agent)
            this.ship_agent_errors = this.get_ship_agent_errors
            if(Object.keys(this.ship_agent_errors).length === 0){
                this.toggleDialog();
                this.resetForm();
                return true
            }
            return false

        },
        async handleSubmit(isFormValid) {
            this.submitted = true;
            
            if (!isFormValid) {
                return;
            }

            let res = await this.add_ship_agent()

            if (res){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Ship agent added', life: 3000});
            }
        },
        toggleDialog() {
            this.showMessage = !this.showMessage;
            this.closeModal()

            if(!this.showMessage) {
                this.resetForm();
            }
        },
        resetForm() {
            this.name = '';
            this.id_cruise_line = null;
            this.submitted = false;
        }
    },
    validations() {
        return {
            name: { required },
            id_cruise_line: { required },

        }
    },
};
</script>

<style scoped>

:deep(.p-chip-text){
    font-size: 11px;
}

</style>